<template>
  <b-modal
    :visible="getShowItemModal"
    size="lg"
    centered
    hide-footer
    hide-header
    no-close-on-backdrop
    no-close-on-esc
  >
    <div class="container-fluid">
      <b-row>
        <b-col cols="3">
          <span>{{ $t("globals.category") }}:</span>
          <b-form-select size="sm" v-model="item.type" :options="typeOptions" />
          <span>{{ $t("globals.item") }}:</span>
          <b-form-select
            size="sm"
            :disabled="item.type === ''"
            v-model="item.name"
            :options="itemOptions"
          />
        </b-col>
        <b-col cols="2">
          <span>{{ $t("globals.price_monthly") }}:</span>
          <b-input
            :placeholder="
              currencyFormat(item.priceMonthly, item.currency).toString()
            "
            type="number"
            size="sm"
            disabled
          >
          </b-input>
          <span>{{ $t("globals.price_once") }}:</span>
          <b-input
            :placeholder="
              currencyFormat(item.priceOneTime, item.currency).toString()
            "
            type="number"
            size="sm"
            disabled
          >
          </b-input>
        </b-col>
        <b-col cols="2">
          <span>{{ $t("globals.quantity") }}:</span>
          <b-input
            v-model.number="item.quantity"
            :disabled="item.name === ''"
            min="0"
            type="number"
            size="sm"
          >
          </b-input>
          <span>{{ $t("globals.discount_per_item") }}:</span>
          <b-input
            :placeholder="
              currencyFormat(item.discount, item.currency).toString()
            "
            disabled
            min="0"
            type="number"
            size="sm"
          >
          </b-input>
        </b-col>
        <b-col cols="2" v-if="getUserSystem !== 'Cartracker'">
          <span>{{ $t("globals.vat") }}:</span>
          <b-input
            v-model.number="item.vat"
            :disabled="item.name === ''"
            min="0"
            type="number"
            size="sm"
          >
          </b-input>
        </b-col>
        <b-col>
          <div style="float: right;">
            <span>{{ $t("globals.total") }}:</span>
            <h3 class="text-secondary">
              {{ currencyFormat(modalTotal, item.currency) }}
            </h3>
          </div>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col>
          <b-btn
            :disabled="item.name === ''"
            style="float: right; margin: 0.3em;"
            @click="saveThisItem"
            variant="success"
          >
            {{ $t("globals.save") }}
          </b-btn>
          <b-btn
            style="float: left; margin: 0.3em;"
            @click="cancel()"
            variant="warning"
          >
            {{ $t("globals.cancel") }}
          </b-btn>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import { currencyFormat } from "@/helpers/price";

export default {
  props: {
    listOfPrices: Array,
    saveItem: Function
  },
  data() {
    return {
      priceList: [],
      typeOptions: [""],
      itemOptions: [""],
      item: {
        id: 0,
        type: "",
        name: "",
        priceMonthly: 0,
        priceOneTime: 0,
        quantity: 1,
        discount: 0,
        vat: 0,
        currency: "EUR",
        is_device: false,
        kpi_type: "",
        exact_code_id: 0
      }
    };
  },
  methods: {
    ...mapMutations(["setShowItemModal"]),
    currencyFormat,
    saveThisItem() {
      this.saveItem(this.item);
      this.cleanData();
    },
    cancel() {
      this.cleanData();
      this.setShowItemModal(false);
    },
    cleanData() {
      this.priceList = [];
      this.typeOptions = [""];
      this.itemOptions = [""];
      this.item.id = 0;
      this.item.type = "";
      this.item.name = "";
      this.item.priceMonthly = 0;
      this.item.priceOneTime = 0;
      this.item.quantity = 1;
      this.item.discount = 0;
      this.item.vat = 0;
      this.item.is_device = false;
      this.item.kpi_type = "";
      this.item.exact_code_id = 0;
      this.item.billing_item_id = null;
    }
  },
  computed: {
    ...mapGetters(["getShowItemModal", "getUserSystem"]),
    modalTotal() {
      let itemPrice =
        this.item.priceMonthly === 0
          ? this.item.priceOneTime
          : this.item.priceMonthly;

      return (itemPrice - this.item.discount) * this.item.quantity;
    }
  },
  watch: {
    "item.type": function() {
      if (this.getShowItemModal) {
        this.itemOptions = [
          ...new Set(
            this.priceList
              .map(curItem => {
                if (curItem.item_type === this.item.type && curItem.displayed === true)
                  return curItem.item_name;
              })
              .filter(name => name !== undefined)
          )
        ];

        this.item.priceMonthly = 0;
        this.item.priceOneTime = 0;
        this.item.discount = 0;
        this.item.quantity = 1;
        this.item.name = "";
        this.item.is_device = false;
        this.item.vat = 0;
        this.item.kpi_type = "";
        this.item.exact_code_id = 0;
      }
    },
    "item.name": function() {
      if (this.getShowItemModal) {
        if (this.item.name !== "") {
          let itemArr = this.priceList
            .filter(item => item.item_name === this.item.name)
            .sort((a, b) => a.fleet_size - b.fleet_size);

          if (itemArr.length > 0) {
            this.item.priceMonthly = parseInt(itemArr[0].price_per_month);
            this.item.priceOneTime = parseInt(itemArr[0].price_one_time);
            this.item.currency = itemArr[0].currency;
            this.item.is_device = itemArr[0].is_device;
            this.item.vat = itemArr[0].vat;
            this.item.kpi_type = itemArr[0].kpi_type;
            this.item.exact_code_id = itemArr[0].exact_code_id;
            this.item.billing_item_id = Number(itemArr[0].billing_item_id);
          }
          this.item.quantity = 1;
        }
      }
    },
    "item.quantity": function() {
      if (this.getShowItemModal) {
        let itemIndex = 0;
        let itemArr = this.priceList
          .filter(item => item.item_name === this.item.name)
          .sort((a, b) => a.fleet_size - b.fleet_size);

        if (itemArr.length > 0) {
          for (let i = 0; i < itemArr.length; i++) {
            if (this.item.quantity < itemArr[i].fleet_size) {
              itemIndex = i;
              // Break loop
              i = itemArr.length;
            }
          }
          this.item.priceMonthly = itemArr[itemIndex].price_per_month;
          this.item.priceOneTime = itemArr[itemIndex].price_one_time;
        }
      }
    },
    getShowItemModal: function(val) {
      if (val) {
        this.item.id = Date.now();
        this.priceList = this.listOfPrices;
        this.typeOptions = [
          ...new Set(this.priceList.map(item => item.item_type))
        ];
        if (this.typeOptions.length > 0) {
          this.item.type = this.typeOptions[0];
        }
      }
    }
  }
};
</script>
